import { useTranslation } from 'react-i18next';

export const EmptyFieldValue = () => {
  const { t } = useTranslation();
  return (
    <span className="text-sm text-text-neutral-secondary italic" data-testid="empty-field-value">
      {t(($) => $.adaptivePlanner.itemPanel.customFields.emptyValue)}
    </span>
  );
};
